import type { FavLike } from '../lib/regulars';
import { fetchFoodStats, type FoodStat } from './entries';
import { fetchFavorites } from './favorites';

// "הקבועים שלי" = המועדפים שלה (בר, 29.09.2026). ההיסטוריה משמשת רק לסדר — מה שנאכל בארוחה שנבחרה
// ובשעה הזו קודם. המסך מסדר בעצמו (buildRegulars), כי החלפת ארוחה בו מסדרת מחדש בלי לפנות לרשת.

export interface RegularsSource { favs: FavLike[]; stats: FoodStat[] }

/**
 * כשל במועדפים נזרק — כדי שהמסך יגיד "אין חיבור" ולא "עוד אין לך מועדפים" (אותו לקח כמו loadDay
 * שהמיר כשל רשת ל-0). כשל בהיסטוריה רק מבטל את הסידור.
 */
export async function fetchRegularsSource(): Promise<RegularsSource> {
  const [favs, stats] = await Promise.allSettled([fetchFavorites(), fetchFoodStats()]);
  if (favs.status === 'rejected') throw favs.reason;
  return { favs: favs.value, stats: stats.status === 'fulfilled' ? [...stats.value.byName.values()] : [] };
}
